import type { MantineTheme } from '@mantine/core';
import type { BalanceSheetRow } from './useBalanceSheetTableQuery';
import { BALANCE_SHEET_MAX_DEPTH } from './_utils';

export const getBalanceSheetTableCellStyle = (
  theme: MantineTheme,
  { rowDepth, type }: { rowDepth: number; type: BalanceSheetRow['type'] }
) => {
  const depth = BALANCE_SHEET_MAX_DEPTH - rowDepth;

  const bg = theme.colors.gray[depth];

  if (bg && type !== 'account') {
    return {
      backgroundColor: `${bg}!important`,
      fontWeight: 'bold',
    };
  }

  return {
    backgroundColor: `${theme.white}!important`,
    fontWeight: 'normal',
  };
};
